import "./ManagerProfile.module.css";
import Header from "@/reusable_sections/Header";
import Background from "./sections/Background";
import Expertise from "./sections/Expertise";
import Qualifications from "./sections/Qualifications";
import ContactAppointment from "./sections/ContactAppointment";
import Footer from "@/reusable_sections/Footer";
export default function ManagerProfilePage() {
  return <div>
      <Header />
      <Background />
      <Expertise />
      <Qualifications />
      <ContactAppointment />
      <Footer />
    </div>;
}